import * as PropTypes from "prop-types";

export const Bounds = PropTypes.shape({
  startMinuts: PropTypes.number,
  startHours: PropTypes.number,
  start: PropTypes.number,
  endMinutes: PropTypes.number,
  endHours: PropTypes.number,
  end: PropTypes.number,
}).isRequired;
